import { useCallback, useEffect, useRef, useState } from "react";
import type { CapaRecord } from "./domain/models";
import { capaGateway } from "./infrastructure/capa-gateway";

export function useCapaListWorkspace(scopeKey: string, dataRefreshVersion: number, notify: (message: string) => void) {
  const [records, setRecords] = useState<CapaRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const hasLoaded = useRef(false);
  const request = useRef(0);
  const current = useRef(scopeKey);
  const loadedScope = useRef(scopeKey);
  const notifyRef = useRef(notify);
  current.current = scopeKey;
  notifyRef.current = notify;
  const load = useCallback(async () => {
    const sequence = ++request.current;
    const requestedScope = current.current;
    if (!hasLoaded.current || loadedScope.current !== requestedScope) setLoading(true);
    try {
      const result = await capaGateway.list();
      if (sequence !== request.current || requestedScope !== current.current) return;
      loadedScope.current = requestedScope;
      setRecords(result);
    } catch (error) {
      if (sequence === request.current && requestedScope === current.current) notifyRef.current(error instanceof Error ? error.message : "DÖF kayıtları alınamadı.");
    } finally {
      if (sequence === request.current && requestedScope === current.current) { hasLoaded.current = true; setLoading(false); }
    }
  }, []);
  useEffect(() => {
    void load();
    return () => { request.current++; };
  }, [load, scopeKey, dataRefreshVersion]);
  return { records: loadedScope.current === scopeKey ? records : [], loading, load };
}
